import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ApiCallConfig } from "@src/utils/api-client";

/**
 * Builds the callApi config for the insurance-package endpoint.
 * Normalises lookup_state to uppercase before sending.
 */
export function buildInsurancePackageConfig(
  user_uuid: string,
  context_id: string,
  lookup_state: string,
  package_exclusions?: boolean,
): ApiCallConfig {
  return {
    method: HTTP_METHODS.GET,
    endpoint: INTERNAL_API_ENDPOINTS.INSURANCE_PACKAGE,
    queryParams: {
      user_uuid,
      context_id,
      lookup_state: lookup_state.trim().toUpperCase(),
      ...(package_exclusions !== undefined ? { package_exclusions } : {}),
    },
  };
}
